import React from 'react';
import Banner from '../../components/Banner/banner';
import SEO from '../../components/SEO/SEO';
import briefImage from '../../assets/book/Laura-Candela-6.jpg';
import imgBanner from '../../assets/img/Laura-Candela-PortadaFull.jpg';
import { useTranslation } from 'react-i18next';
import './home.scss';

const Home = () => {
  const [t] = useTranslation('global');

  return (
    <main className="globalContainer">
      <SEO title={t('About')} canonicalPath="/" />
      
      <Banner name={imgBanner} alt="Laura Candela Cover" />

      <section className="globalSection" aria-label="About Laura Candela">
        <div className="homeIntro">
          <h1 className="sectionTitle">{t('About')}</h1>
          <p className="textUrgent">{t('ShortBrief')}</p>
        </div>
      </section>

      <section className="dataContainer brief" aria-label="Biography">
        <div className="dataContentWrapper">
          <img
            className="dataImage"
            src={briefImage}
            alt="Laura Candela Portrait"
            loading="lazy"
          />
          <article className="briefP">
            <h2 className="dataTitle">{t('LongBriefTitle')}</h2>
            <p className="paragraf">{t('LongBrief1')}</p>
            <p className="paragraf">{t('LongBrief2')}</p>
            <p className="paragraf">{t('LongBrief3')}</p>
            <p className="paragraf">{t('LongBrief4')}</p>
            <p className="paragraf">
              {t('LongBrief5')}
              <a
                target="_blank"
                rel="noopener noreferrer"
                className="linkText"
                href="https://brossontalent.com/D/product/laura-candela/"
              >
                Brosson Talent.
              </a>{' '}
              {t('LongBrief6')}
            </p>
          </article>
        </div>
      </section>
    </main>
  );
};

export default Home;